import React from 'react';
import '../../static/css/main.css';
import '../../static/css/ie.css';
import axios from "axios";
import PageStart from "../registration/start";
import PageRequest from "../registration/confirmation";
import PageHome from "./home";
import PageSuccess from "../registration/success";
import PageError from "../registration/error";
import PageLoading from "../server/preload";
import {connect} from "react-redux";
import {userAction} from "../../store/actions/userAction";
import * as consts from "../../store/constants/userInfo";

function makeId(length) {
  let result = '';
  let characters = '0123456789abcdef';
  let charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
let spanId = makeId(16);
let traceId = localStorage.getItem('f.traceid');
if(!traceId) {
  localStorage.setItem('f.traceid', makeId(16));
  traceId = localStorage.getItem('f.traceid');
}

axios.defaults.headers = {
  'Content-Type': 'application/json',
  'x-b3-traceid': traceId,
  'x-b3-spanid': spanId,
  // 'Auth-Token': 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImFhZThjYTFkOWYwN2VmZGUzY2ViNzUwYzFiYzMzYTMzNGNiNjIxNzIifQ.eyJhdWQiOlsiYXV0aC1zZXJ2aWNlIl0sImV4cCI6MTYxOTA4ODgxMywidXNlcl9uYW1lIjoiZGFuaWxvdjUiLCJqdGkiOiJiY2U1NjE4MC00OGJkLTQ1YjctOWZmNi00YzIxNWMwZDAwNDEiLCJjbGllbnRfaWQiOiJlbGYiLCJzY29wZSI6WyJyZWFkIiwid3JpdGUiXSwiYXV0aF9wcm92aWRlciI6ImZha3R1cmEiLCJ1c2VyX3NpZ25hdHVyZSI6eyJzdWJqZWN0X2RuIjoiQ049ZGFuaWxvdjUsIE9VPWxpdGUgY2xpZW50IDEzMDM0ODAsIE89ZmFrdHVyYS5saXRlLCBMPU5vdm9zaWJpcnNrLCBDPVJVIiwiaXNzdWVyX2RuIjoiQ049Q2xhc3MgMiBDQSwgT1U9Q0FzLCBPPUZUQywgQz1SVSJ9LCJ1c2VyX2lkIjoiMjQ1OTk0Mjg3NSIsImlzcyI6Imh0dHA6Ly9lcm1hay5mdGMucnU6OTYwMCJ9.Z_CEggKZ3_IXAQ6WrIBC6NtS2lWEc_g1wc073clcNhIZSOpnBMUxqd1LxfB_1hJppXFKNLgnI17aePuVwm4GsVh1r3V5af2Tz5H03NtTrdnZAoQo-6HveZsJ4pYYiegLPjuy16E9bMkedUG66YgnQdJGDNHHyBeSgsxlHcKwE0J7-H75h5LocQkSg_ovdVd17WlHEO0AJ6A9iyKMF-4ES6wzbJWCRNF9gcAw5rcMH9-xZYlsP3DRyXlEIgQ0S1CBAMQg0hHx4s0GBfTh0GRivkryCiiRM96z_NttIEMQ3Ot36PQpgNL-L114af6wCwVLNgCfuX59eUlMg9CNSgpaRg',
  // 'External-Info' : '%7B%22bankId%22%3A11991%7D'
  //'External-Info' : '%7B%22bankId%22%3A874856%7D'
  //'External-Info' : '%7B%22bankId%22%3A29300%7D' /* gribanov */
};

axios.interceptors.request.use(request => {
  request.headers['x-b3-spanid'] = makeId(16);
  return request;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  if (response.data?.result?.status === 'AUTH_FAILED') {
    localStorage.removeItem('f.traceid');
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

class Main extends React.Component {
  componentDidMount() {
    this.props.fetchData(process.env.REACT_APP_GATE + "registration/stage", this, consts.REGISTRATION_STAGE);
  }

  render() {
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "AUTH_FAILED":
        case "NOTAVAILABLE":
        case "TIMEOUT":
          return <PageStart/>;
        case "ERROR":
          return <PageError
            infoTitle="Что-то пошло не так"
            infoMessage={this.props.data.items.result.errorMessage}
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        default:
          switch (this.props.data.items.data.status) {
            case "FAILED":
              return <PageError
                infoTitle="Регистрация невозможна"
                infoMessage={<div>При обработке заявления произошла ошибка.<br/>Отправьте, пожалуйста, повторный запрос.
                </div>}
                infoErrorMessage={this.props.data.items.data.errorMessage}
                updateButton="Закрыть"
              />;
            case "IN_PROGRESS":
              return <PageSuccess
                infoTitle="Заявление успешно отправлено"
                infoMessage={<div>Ваши данные направлены в Федеральную налоговую службу для регистрации статуса
                  самозанятого.<br/>Как только статус будет подтверждён, вы получите доступ к личному кабинету.</div>}
                infoButton="Вернуться в Интернет банк"
                infoLink={process.env.REACT_APP_ELF_URL}
                reloadButton="Проверить статус"
              />;
            case "WAITING_CONFIRMATION":
              return <PageRequest/>;
            case "SUCCESS":
              return <PageHome banner="true"/>;
            case "COMPLETED":
              return <PageHome/>;
            case "NULL":
            case null:
              return <PageStart/>;
            default:
              return <PageLoading/>;
          }
      }
    } else {
      return <PageLoading/>;
    }
  }
}

const mapStateToProps = state => ({data: state.registrationStage})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(userAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);